import { gql } from "@apollo/client";

export default gql`
  mutation ToggleUsersCanRequestContentTranslation($vendorId: ObjectId!, $requestContentTranslationAllowed: Boolean!) {
    toggleUsersCanRequestContentTranslation(
      vendorId: $vendorId
      requestContentTranslationAllowed: $requestContentTranslationAllowed
    )
  }
`;
